import React from 'react';

import { ReactComponent as CloseIcon } from '../../../assets/svg/close_24px.svg';
import { ReactComponent as InfoSignIcon } from '../../../assets/svg/info_24px.svg';
import { ReactComponent as WarningIcon } from '../../../assets/svg/warning_amber_24px.svg';
import styles from '../NewPointDetails.module.scss';

export type PointDetailsStatusBarProps = {
    statusMsg: string;
    isNotification: boolean;
    onClear: () => void;
};

export const PointDetailsStatusBar: React.FC<PointDetailsStatusBarProps> = ({
    statusMsg,
    isNotification,
    onClear
}) => {
    if (statusMsg === '') {
        return null;
    }

    return (
        <div
            className={styles.PointDetailsStatusBar}
            style={
                isNotification
                    ? { backgroundColor: 'rgba(255, 125, 2, 0.2)' }
                    : { backgroundColor: 'rgba(176, 8, 8, 0.2)' }
            }
        >
            <div style={{ display: 'flex', gap: '8px' }}>
                {isNotification ? <InfoSignIcon /> : <WarningIcon />}

                <span
                    style={
                        isNotification
                            ? { color: '#ff7c02' }
                            : { color: '#b00808' }
                    }
                >
                    {statusMsg}
                </span>
            </div>

            <CloseIcon
                style={{ cursor: 'pointer', fill: 'rgb(17, 17, 17)' }}
                onClick={onClear}
            />
        </div>
    );
};